import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadGoogleAnalytics, trackPageView } from "./ga4";

export const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const sendPageView = async () => {
      try {
        await loadGoogleAnalytics();
        if (!cancelled) trackPageView(location);
      } catch {
        // No consent or unavailable script: send nothing.
      }
    };

    const onReady = () => {
      if (!cancelled) trackPageView(location);
    };

    sendPageView();
    window.addEventListener("analytics-ready", onReady);
    return () => {
      cancelled = true;
      window.removeEventListener("analytics-ready", onReady);
    };
  }, [location.pathname, location.search, location.hash]);

  return null;
};
